import { useCallback } from "react";
import { Link } from "react-router-dom";

import Button from "@/components/button/button";
import {
  useAuthStoreActions,
  useCognitoSignOutUrlQuery,
  useIsAuthenticated,
} from "@/features/shared/features/authentication";

import NavigationItem from "./navigation-item";
import styles from "./navigation.module.css";

const ORIGIN = String(new URL(document.location.origin));

export default function NavigationAuthButton() {
  const { data } = useCognitoSignOutUrlQuery(ORIGIN);
  const { clearAuthToken } = useAuthStoreActions();
  const isAuthenticated = useIsAuthenticated();

  const onClick = useCallback(() => {
    clearAuthToken();
    if (data) {
      window.location.href = data;
    }
  }, [data]);

  if (!data) return null;

  if (!isAuthenticated) {
    return (
      <Link to="/auth/login">
        <NavigationItem icon="power">Login</NavigationItem>
      </Link>
    );
  }

  return (
    <Button onClick={onClick} tabIndex={0} className={styles.navigationButton}>
      <NavigationItem icon="power">Log out</NavigationItem>
    </Button>
  );
}
